import { render, staticRenderFns } from "./BackgroundElement.vue?vue&type=template&id=a156d5b4&scoped=true&"
import script from "./BackgroundElement.vue?vue&type=script&lang=js&"
export * from "./BackgroundElement.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundElement.vue?vue&type=style&index=0&id=a156d5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156d5b4",
  null
  
)

export default component.exports